import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import UrlData from "../../Redirect/url-lookuptable.json";

const DynamicRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathSegments = location.pathname.split("/").filter(Boolean);// ["dünya", "depremlerde-yaralananlarin-sayisi", "foo"]

    let slugCandidate = pathSegments.find((segment) =>// Slug’ı bul: yani JSON’daki oldUrl ile eşleşen parça
      UrlData.some((url) => url.oldUrl === `/${segment}/`)
    );

    if (!slugCandidate && pathSegments.length > 0) {  // Hiçbiri eşleşmezse son parçayı dene
      slugCandidate = pathSegments[pathSegments.length - 1];
    }

    const oldUrl = `/${slugCandidate}/`;
    console.log(oldUrl)
    const matchingUrl = UrlData.find((url) => url.oldUrl === oldUrl);

    if (matchingUrl) {
     window.location.href = window.location.origin + matchingUrl.newUrl;
    } else {
     navigate("/not-found", { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default DynamicRedirect;
